import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface EarningsTranscript {
  symbol: string;
  period: string;
  year: number;
  date: string;
  content: string;
}

export interface EarningsTranscriptResponse {
  data: EarningsTranscript[];
}

export const useEarningsTranscript = (
  symbol: string | undefined,
  year: string | undefined,
  quarter: string | undefined,
  limit: number = 1
) => {
  return useQuery({
    queryKey: ['earningsTranscript', symbol, year, quarter, limit],
    queryFn: async () => {
      if (!symbol || !year || !quarter) {
        throw new Error('Symbol, year, and quarter are required');
      }

      const response = await api.get<EarningsTranscript[]>('/earnings-transcript', {
        params: {
          symbol: symbol.toUpperCase(),
          year,
          quarter,
          limit,
        },
      });

      return response.data;
    },
    enabled: !!(symbol && year && quarter),
    staleTime: 2.5 * 60 * 1000, // 2.5 minutes for fresh transcript data
    gcTime: 1000 * 60 * 60 * 2, // 2 hours
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};